import React, { Component } from "react";
import { Form, Button, Divider } from "antd";
import { connect } from "dva";
import FormCreate from "@/components/FormCreate/index";
import styles from "./SelfForm.less";
import { ENV } from "../../../../../services/utils";

const { Item } = Form;
const { FormTitle, FormTextArea, FormInputNumber, FileUpload } = FormCreate;

@Form.create()
@connect(({ self }) => ({
  projectId: self.currentProjectId,
  index: self.index,
  spinProps: self.spinProps
}))
class SelfForm extends Component {
  state = {
    newAppendix: "",
    filesNumber: 0
  };

  handleSubmit = () => {
    const { newAppendix } = this.state;
    const {
      dispatch,
      form,
      projectId,
      index,
      appendix,
      callback,
      update,
      templateType,
      org // org是用来识别是否是个性化指标的，父组件传进来的
    } = this.props;
    const { id: indexId } = index;
    const { validateFields } = form;

    validateFields((err, { score, remark }) => {
      if (!err) {
        dispatch({
          type: "self/submitAddReport",
          payload: {
            type: templateType, // 模版类型
            indexId,
            projectId,
            score: Number(score),
            remark,
            appendix: newAppendix || appendix,
            org: org || false
          },
          callback: () => {
            callback();
            update(false);
          }
        });
      }
    });
  };

  handleFileGroupId = (fileId, length) => {
    this.setState({
      newAppendix: fileId,
      filesNumber: length
    });
  };

  // handleValidate = (rule, value) => {};

  render() {
    const {
      form,
      appendix,
      score,
      remark,
      index,
      templateType = 1,
      reRender
    } = this.props;
    const { filesNumber } = this.state;

    const { score: indexGrade } = index;

    const tailFormItemLayout = {
      wrapperCol: {
        sm: {
          span: 12,
          offset: 3
        }
      }
    };

    const selfScoreProps = {
      form,
      value: score || 0,
      label: "自评分数",
      keyName: "score",
      isRequired: true,
      step: 0.1,
      precision: 2,
      max: Number(indexGrade)
    };

    const selfNormValueProps = {
      form,
      value: score,
      keyName: "score",
      label: "指标值",
      formItemProps: {
        required: true
      },
      myselfRules: [
        {
          validator: (rule, value, callback) => {
            if (value === '0' || value === 0) {
              return callback();
            }
            if (!value) {
              return callback(new Error("请输入指标值"));
            }
            if (!Number(value)) {
              return callback(new Error("请输入数字"));
            }
            return callback();
          }
        }
      ]
    };

    const selfNormRemarkProps = {
      form,
      value: remark,
      keyName: "remark",
      label: templateType === 3 ? "说明" : "自评说明",
      isRequired: true,
      rows: 5,
      myselfRules: [
        {
          required: true,
          message: "请输入评估说明"
        },
        {
          max: 1000,
          message: "评估说明不能超过1000字"
        }
      ]
    };

    const selfFileProps = {
      form,
      groupId: appendix,
      edit: 0,
      APIEnv: ENV,
      type: "pc",
      handleFileGroupId: this.handleFileGroupId,
      key: appendix,
      fileCount: filesNumber
    };

    return (
      <div className={styles.selfForm}>
        <div className="normDetailTitle">
          <Divider orientation="left">自查自评</Divider>
        </div>
        <div>
          {reRender && (
            <FormCreate>
              {(templateType === 1 || templateType === 2) && (
                <FormInputNumber {...selfScoreProps} />
              )}
              {templateType === 3 && <FormTitle {...selfNormValueProps} />}
              <FormTextArea {...selfNormRemarkProps} />
              <FileUpload {...selfFileProps} />
              <Item {...tailFormItemLayout}>
                <Button
                  size="default"
                  type="primary"
                  onClick={this.handleSubmit}
                >
                  填报确认
                </Button>
              </Item>
            </FormCreate>
          )}
        </div>
      </div>
    );
  }
}

export default SelfForm;
